import { AutoTooltip } from "lib/common";
import Constants from "const/Constants";
import DateTimeFormats from "const/DateTimeFormats";
import React from "react";
import moment from "moment";

const IssueDateCell = ({ value }) => {
  return (
    <AutoTooltip active={!!value}>
      {value
        ? moment.utc(value).format(DateTimeFormats.DATE_TEXT)
        : Constants.EMPTY_PLACEHOLDER}
    </AutoTooltip>
  );
};

export default React.memo(IssueDateCell);
